import { Address } from "../../common/models/address.model";
import { OrganizationComplianceDetails } from "../../common/models/organization.model";

export class CountyEngineersReportModel {
    id: string;
    organizationName: string;
    organizationNumber: string;
    organizationRBDMSNumber: string;
    organizationStreet: string;
    organizationSuite: string;
    organizationPoBox: string;
    organizationCity: string;
    organizationState: string;
    organizationZipCode: string;
    organizationPhoneNumber: string;
    wellDirection: string;
    applicationSubmitDate: string;
    applicationName: string;
    applicationType: string;
    applicationNumber: string;
    wellName: string;
    wellNumber: string;
    section: string;
    lot: string;
    county: string;
    township: string;
    quadrangle: string;
    wellType: string;
    isExistingWell: string;
    permittedFormations: string;
    acreage: string;
    latitude: string;
    longitude: string;
    egress: string;
    ingress: string;
}

export class PermitApplicationTrackingSummaryReportModel {
    permitsIssued: number;
    permitsDenied: number;
    permitsDefinedHorizontal: number;
    permitsMarcellusShale: number;
    permitsUticaShale: number;
    permitsToDrill: number;
    permitsToAbandon: number;
    permitsToDeepenHorizontal: number;
    permitsToDeepenVertical: number;
    permitsToConvert: number;
    permitsToPlugBack: number;
    permitsToReviseLocation: number;
    permitsToReopen: number;
    permitsToReissue: number;
    stratigraphicPermits: number;
    total: number;
    summeriesByOwner: PermitApplicationSummaryByOwnerReportModel[];
}

export class PermitApplicationSummaryByOwnerReportModel {
    organizationName: string;
    organizationNumber: string;
    organizationRBDMSNumber: string;
    applications: number;
    verticalApplications: number;
    directionalApplications: number;
    otherHorizontalApplications: number;
    nonUrbanApplications: number;
    urbanApplications: number;
    definedHorizontalApplications: number;
    marcellusShaleApplications: number;
    uticaShaleApplications: number;
    oilAndGasApplications: number;
    classIIEnhancedRecoveryApplications: number;
    classIIDisposalWellBrineApplications: number;
    classIIISolutionMiningApplications: number;
    liquidGasStorageApplications: number;
    gasStorageApplications: number;
    permitsIssued: number;
    permitsDenied: number;
    permitsWithdrawnOrCanceled: number;
    permitsPending: number;
    stratigraphicApplications: number;
}

export class PermitApplicationMonthlyTrackingReportModel {
    monthSubmitted: string;
    totaApplications: number;
    expeditedApplications: number;
    permitsIssued: number;
    expediteFees: number;
    applicationFees: number;
    poolFees: number;
    totalFees: number;
    plugAndAbandonApplications: number;
    stratigraphicApplications: number;
}

export class PermitsIssuedReportModel {
    programArea: string;
    applicationsReceived: number;
    permitsIssued: number;
    permitsDenied: number;
    permitsPending: number;
}

export class RevenueByApplicationTypeReportModel {
    applicationType: string;
    totalApplications: number;
    applicationFees: number;
    poolFees: number;
    expediteFees: number;
    totalFees: number;
}


export interface InsuranceDataListItem {
    id: string;
    ricsOrganizationId: string;
    rbdmsOwnerNumber: string;
    ownerName: string;
    insurancePolicyType: string;
    policyNumber: string;
    limit?: number;
    effectiveDate?: Date;
    expirationDate?: Date;
    releaseDate?: Date;
    environmentalEndorsement: boolean;
    isActive: boolean;
    surplusInsurance: boolean;
    replacementApprovalDate?: Date;
    compliance?: OrganizationComplianceDetails;
    insurer: string;
    agency: string;
    agent: string;
    agentEmail: string;
    agentPhone: string;
    organizationPrimaryContact: string;
    organizationAddress: Address;
    organizationEmail: string
    organizationPhone: string;

}


export interface FinancialComplianceProjectionRequest {
    projectionDate: Date;
    organizationIds?: string[];
    includeBonding?: boolean;
    includeInsurance?: boolean;
}

export interface StratigraphicApplicationReportModel {
    operator: string;
    organizationId: string;
    operatorRBDMSNumber: string;
    apiNumber: string;
    dateStratigraphicPermitIssued: Date;
    dateStratigraphicPermitExpires: Date;
    dateOfOriginalSpud: Date;
    dateTotalDepthReached: Date;
    datePlugged: Date;
    dateConversionPermitSubmitted: Date;
    conversionPermitWellType: string;
    dateConversionPermitIssued: Date;
    dateConversionPermitExpires: Date;
    conversionCompleteDate: Date;
    financialAssuranceSubmittedDate: Date;
    financialAssuranceAmount: number;
    financialAssuranceType: string;
    systemCheckDate1: Date;
    systemCheckDate2: Date;
    systemCheckDate3: Date;
}